import {Pipe, PipeTransform} from '@angular/core';
import {Borough} from "../model/borough";

export const boroughToText = (borough: Borough): string => {
  switch (borough) {
    case "manhattan":
      return "Manhattan";
    case "brooklyn":
      return "Brooklyn";
    case "queens":
      return "Queens";
    case "bronx":
      return "The Bronx";
    case "staten-island":
      return "Staten Island";
  }
}

@Pipe({
  name: 'boroughToText',
  standalone: true
})
export class BoroughToTextPipe implements PipeTransform {

  transform(borough: Borough): string {
    return boroughToText(borough);
  }
}
